var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Variant2",
    clipPath: "url(#clip0_57817_7324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1266 1.73555L20.7845 9.49448C20.9639 9.88445 21.3168 10.1571 21.7276 10.2228L29.9149 11.4714C30.2472 11.5192 30.5473 11.7031 30.7485 11.9822C30.9498 12.2614 31.0355 12.6126 30.9866 12.9578C30.9454 13.2415 30.8147 13.503 30.6151 13.701L24.6853 19.7654C24.3856 20.0643 24.2512 20.5004 24.3281 20.9248L25.7569 29.4715C25.8603 30.1757 25.403 30.8365 24.7282 30.9579C24.4499 31.0032 24.165 30.9564 23.9137 30.8241L16.6122 26.796C16.2475 26.5871 15.8053 26.5871 15.4406 26.796L8.09625 30.8538C7.48007 31.1828 6.72417 30.9383 6.39591 30.3039C6.26792 30.0481 6.22282 29.7561 6.26731 29.4715L7.69617 20.9248C7.76528 20.5009 7.63206 20.0685 7.33896 19.7654L1.36633 13.701C0.87789 13.1858 0.87789 12.3581 1.36633 11.843C1.56567 11.651 1.8135 11.5221 2.08076 11.4714L10.2681 10.2228C10.6769 10.1523 11.028 9.88113 11.2112 9.49448L14.869 1.73555C15.0136 1.42095 15.2741 1.18039 15.5916 1.06845C15.909 0.956512 16.2564 0.982671 16.5551 1.141C16.8015 1.27098 17.0017 1.47923 17.1266 1.73555Z",
    fill: "white",
    fillOpacity: 0.6,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57817_7324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingStar);
export default __webpack_public_path__ + "static/media/pendingStar.3cd5c66d1e75991170a0c38ac59aeea2.svg";
export { ForwardRef as ReactComponent };